import React, { useRef, useEffect, useState } from 'react';


const ConfigViewElement = ({
  val=null,
  viewElement=<></>
}) => {
  return (
    <div className='flex border-b-2 border-gray-200'>
      <div className="w-2/6 flex justify-between border-r-2 border-gray-200 p-3">
        <div className='break-all mr-3'>{val}</div>
      </div>
      <div className='w-4/6'>
        {viewElement}
      </div>
    </div>
  )
}

const LookerConfigViewGrid = ({
    lookerConfigData={}
}) => {

  return (
    <>

      <div className="border border-gray-200 m-4 mb-8">
        {
          ["enabled", "scorecardOnlyAccess"].map(val => (
            (val in lookerConfigData) &&
            <ConfigViewElement
              val={val}
              viewElement={
                <div className='px-4 py-3 h-full flex items-center'>
                  {(lookerConfigData[val])? 
                  <span className="text-green-800 bg-green-100 py-1 px-4 rounded-full">True</span>
                  :
                  <span className="text-red-800 bg-red-100 py-1 px-4 rounded-full">False</span>
                  }
                </div>
              }
            />
          )) 
        }

        {
          ["scorecardModelId", "scorecardView", "scorecardCounterKey"].map(val => (
            (val in lookerConfigData) && 
            <ConfigViewElement
              val={val}
              viewElement={
                <div className='px-4 py-3 h-full flex items-center'>
                  {lookerConfigData[val]}
                </div>
              }
            />
          )) 
        }

        {
          ["scorecardFields", "dashboards", "models", "group_ids", "Market"].map(val => (
            (val in lookerConfigData) && 
            <ConfigViewElement
              val={val}
              viewElement={
                <div className='px-4 py-3 h-full flex items-center'>
                  <div className="w-full">
                    {(lookerConfigData[val].length == 0)? 
                      
                      <span className="test-sm text-gray-400">Empty</span>
                      :
                      (
                        <ul className="border border-gray-200 w-full rounded-md divide-y divide-gray-200">
                          {lookerConfigData[val].map(elem => 
                            (
                              <li className="pl-3 pr-4 py-3 flex w-full items-center justify-between text-sm">
                                {elem}
                              </li>
                            )
                          )}
                        </ul>
                      )
                    }
                  </div>
                </div>
              }
            />
          )) 
        }

        {
          ["defaultFilters"].map(val => (
            (val in lookerConfigData) && 
            <ConfigViewElement
              val={val}
              viewElement={
                <>
                  {
                    ["Trated","Walmart Week","Assortment"].map(item => (
                      (val in lookerConfigData && item in lookerConfigData[val]) &&
                      <ConfigViewElement
                        val={item}
                        viewElement={
                          <div className='px-4 py-3 h-full flex item-center'>
                            {lookerConfigData[val][item]}
                          </div>
                        }
                      />
                    ))
                  }

                  {
                    ["Channel"].map(item => (
                      (val in lookerConfigData && item in lookerConfigData[val]) &&
                      <ConfigViewElement
                        val={item}
                        viewElement={
                          <div className='px-4 py-3 h-full flex item-center'>
                            {lookerConfigData[val][item]}
                          </div>
                        }
                      />
                    ))
                  }

                  {
                    ["Market","Region","Organisation","Brand","Retailer","Category","Client","Client Name","Assortment Group","SKU Group","Keyword Group"].map(item => (
                      (val in lookerConfigData && item in lookerConfigData[val]) &&
                      <ConfigViewElement
                        val={item}
                        viewElement={
                          <div className='px-4 py-3 h-full flex item-center'>
                            {(lookerConfigData[val][item].length == 0)? 
                                <span className="test-sm text-gray-400">Empty</span>
                                :
                                (
                                  <ul className="border border-gray-200 w-full rounded-md divide-y divide-gray-200">
                                    {lookerConfigData[val][item].map(elem => 
                                      (
                                        <li className="pl-3 pr-4 py-3 flex w-full items-center justify-between text-sm">
                                          {elem}
                                        </li>
                                      )
                                    )}
                                  </ul>
                                )
                              }
                          </div>
                        }
                      />
                    ))
                  }
                </>          
              }
            />
          ))
        }


        

      </div>


    </>



    )



}








export default LookerConfigViewGrid;